import React from 'react';
import { CircularProgress } from '@material-ui/core';

export function getLabel(loading, label) {
    return loading ? <LoadingProgress /> : label;
}

function LoadingProgress() {
    return (
        <CircularProgress
            size={15}
            thickness={2}
            color='inherit'
        />
    )
}

export default LoadingProgress;
